import * as actions from './actions'
import mutations from './mutations'

const state = () => ({
   justificativa: {},
   justificativa_editar: {},

   items_ocorrencia: [],

   paginaAtual_ocorrencia: null,
   totalDePaginas_ocorrencia: null,
   registrosPorPagina_ocorrencia: null,
   totalDeRegistros_ocorrencia: null,
   possuiPaginaAnterior_ocorrencia: null,
   possuiProximaPagina_ocorrencia: null,
   codigo_ocorrencia: null,
   sucesso_ocorrencia: null,
   mensagens_ocorrencia: [],

   items_grupo_usuario: [],
   paginaAtual_grupo_usuario: null,
   totalDePaginas_grupo_usuario: null,
   registrosPorPagina_grupo_usuario: null,
   totalDeRegistros_grupo_usuario: null,
   possuiPaginaAnterior_grupo_usuario: null,
   possuiProximaPagina_grupo_usuario: null,
   codigo_grupo_usuario: null,
   sucesso_grupo_usuario: null,
   mensagens_grupo_usuario: [],

   items_descricao_detalhes: {},
   items_descricao: [],
   paginaAtual_descricao: null,
   totalDePaginas_descricao: null,
   registrosPorPagina_descricao: null,
   totalDeRegistros_descricao: null,
   possuiPaginaAnterior_descricao: null,
   possuiProximaPagina_descricao: null,
   codigo_descricao: null,
   sucesso_descricao: null,
   mensagens_descricao: []
})

const justificativa = {
   namespaced: true,
   state,
   actions,
   mutations
}

export default {
   justificativa
}
